import React from 'react';

const LockOutlined = ({ color = '#000', width = 16, height = 16, ...props }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width} // Use the width prop or default to 16
			height={height} // Use the height prop or default to 16
			viewBox='0 0 14 14' // Adjusted viewBox to match 16x16 dimensions
			fill='currentColor'
			{...props}
		>
			<path d='M9.917 4.667v-.584A2.92 2.92 0 0 0 7 1.167a2.92 2.92 0 0 0-2.917 2.916v1.75H3.5c-.643 0-1.167.524-1.167 1.167v4.667c0 .643.523 1.166 1.167 1.166h7c.643 0 1.167-.523 1.167-1.166V7c0-.643-.524-1.167-1.167-1.167H5.25v-1.75c0-.964.785-1.75 1.75-1.75s1.75.786 1.75 1.75v.584h1.167ZM10.5 7l.001 4.667H3.5V7h7Z' />
		</svg>
	);
};

export default LockOutlined;
